import React, { useState } from "react";
import { FaBookmark, FaBell, FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const RightNav = () => {
    const Navlinks = [
        {
            id: 1,
            icon: <FaBookmark className="text-white w-10 h-5" />,
            link: "/#Bookmark",
        },
        {
            id: 2,
            icon: <FaBell className="text-white w-10 h-5" />,
            link: "/#Notification",
        },
        {
            id: 3,
            icon: <FaUserCircle className="text-white w-10 h-5" />,
            link: "#Profile",
        },
    ];

    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const navigate = useNavigate();

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const handleLogout = () => {
        setIsDropdownOpen(false);
        // Redirect to the home page
        navigate("/");
    };

    return (
        <div className="relative">
            {/* Main Navigation */}
            <div>
                <ul className="flex items-center gap-3">
                    {Navlinks.map(({ id, icon, link }) => (
                        <li key={id} className="py-4">
                            <a
                                href={link}
                                className="text-lg font-semibold hover:text-blue-500 duration-300 flex items-center gap-2"
                                onClick={() => id === 3 && toggleDropdown()}
                            >
                                {icon}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

            {/* Profile Dropdown */}
            {isDropdownOpen && (
                <div className="absolute right-0 top-12 bg-white text-black w-40 shadow-lg rounded-md">
                    <ul className="space-y-4 p-4">
                        <li>
                            <a href="/profile" className="hover:text-blue-500">View Profile</a>
                        </li>
                        <li>
                            <a href="/settings" className="hover:text-blue-500">Settings</a>
                        </li>
                        <li>
                            <button
                                className="hover:text-blue-500 w-full text-left"
                                onClick={handleLogout}
                            >
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    );
};

export default RightNav;
